@for (group of groups; track group) {
  @if (assets[group].length>0) {
    <div class="{{group}}-investments">
      @if (group !== 'Inactive') {
        <a tabindex="0" role="button" (click)="export()" class="export-btn pull-right d-print-none">Export</a>
      }
      @if (group !== 'Inactive') {
        <h1 class="my-4">{{group}} Investment Summary</h1>
      }
      @if (group === 'Inactive') {
        <h1 class="my-4 inactive_investments"><a class="collapser collapsed" data-toggle="collapse" href="#Inactive_investments">Inactive Historical Investments</a></h1>
      }
      <div id="{{group === 'Inactive' ? 'Inactive_investments' : ''}}" [ngClass]="{'collapse':group === 'Inactive'}">
        <div class="scrollable-wrap">
          <div class="scrollable">
            <div class="scrollable-button left"></div>
            <div class="scrollable-button"></div>
            @if (group !== 'Inactive') {
              <table width="100%" class="NWMtable table-hover">
                <thead>
                  <tr>
                    <td width="38%" valign="top">Investment ({{group}})</td>
                    <td width="15%" valign="top">Current Price&nbsp;($)</td>
                    <td width="12%" valign="top" class="current-market-value-col">Current Market Value&nbsp;($) </td>
                    <td width="10%" valign="top">YTD Return </td>
                    <td width="15%" valign="top">Annualized Return Since Inception</td>
                    <td width="10%" valign="top">Performance Start Date </td>
                  </tr>
                </thead>
                <tbody>
                  @for (asset of assets[group]; track asset) {
                    <tr>
                      <td data-toggle="modal" data-target="#transactionsModal" (click)="onHoldingClick(asset)">
                        <a href="javascript:void(0)">{{asset.ProductName}}{{asset.CusipNumFormated}}</a>
                      </td>
                      <td>{{(asset.CurrentPrice === null? 'N/A' : asset.CurrentPrice | number:'1.2-2' | minusSignToParens | placeholder: '-')}}</td>
                      <td class="current-market-value-col">{{asset.MarketValue >= 1 || asset.MarketValue <= -1 ? (asset.MarketValue | number:'1.0-0' | minusSignToParens) : '-'}}</td>
                      <td>{{asset.YtdReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}</td>
                      <td>
                        @if (isLessThanOneYear(asset.AcctInception, 0)) {
                          @if (asset.InceptionReturn === 0) {
                            N/A
                          }
                          @if (asset.InceptionReturn !== 0) {
                            {{asset.InceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}<span class="ARSI-star" aria-hidden="true" [ngbTooltip]="'Funds are invested for less than one year. Displayed return uses YTD return formula, refer to the FAQ page.'" placement="top" container="body">* </span>
                          }
                        } @else {
                          {{asset.InceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}
                        }
                      </td>
                      <td>{{asset.AcctInception | date:'MMM d, yyyy'}}</td>
                    </tr>
                  }
                  <tr class="totals">
                    <td>{{ group === 'USD' && !isPershing ? 'Total in US Dollars' : 'Total' }}</td>
                    <td></td>
                    <td class="current-market-value-col">{{sumMarketValues(assets[group]) | currency:'USD': 'symbol':'1.0-0' | minusSignToParens | placeholder: '-'}}</td>
                    <td>{{YTDReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}</td>
                    <td>{{InceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}</td>
                    <td></td>
                  </tr>
                  @if (group === 'USD' && !isPershing) {
                    <tr class="totals">
                      <td>Canadian Dollar Equivalent</td>
                      <td></td>
                      <td class="current-market-value-col">{{sumCADMarketValues(assets[group]) | currency:'USD': 'symbol':'1.0-0' | minusSignToParens | placeholder: '-'}}</td>
                      <td>{{CadYTDReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}</td>
                      <td>{{CadInceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}</td>
                      <td></td>
                    </tr>
                  }
                </tbody>
              </table>
            }
            @if (group === 'Inactive') {
              <table width="100%" class="NWMtable">
                <thead>
                  <tr>
                    <td width="55%" valign="top">Investment Name</td>
                    <td width="15%" valign="top">Performance Start Date </td>
                    <td width="15%" valign="top">Date Closed</td>
                    <td width="15%" valign="top">Annualized Return Since Inception</td>
                  </tr>
                </thead>
                <tbody>
                  @for (asset of assets[group]; track asset) {
                    <tr>
                      <td data-toggle="modal" data-target="#transactionsModal" (click)="onHoldingClick(asset)">
                        <a href="javascript:void(0)">{{asset.ProductName}}{{asset.CusipNumFormated}}</a>
                      </td>
                      <td class="text-nowrap">{{asset.AcctInception | date:'MMM d, yyyy'}}</td>
                      <td class="text-nowrap">{{asset.ClosedDate | date:'MMM d, yyyy'}}</td>
                      <td>
                        @if (isLessThanOneYear(asset.AcctInception, 0)) {
                          @if (asset.InceptionReturn === 0) {
                            N/A
                          }
                          @if (asset.InceptionReturn !== 0) {
                            {{asset.InceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}<span class="ARSI-star" aria-hidden="true" [ngbTooltip]="'Funds are invested for less than one year. Displayed return uses YTD return formula, refer to the FAQ page.'" placement="top" container="body">* </span>
                          }
                        } @else {
                          {{asset.InceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
<div class="modal fade" id="transactionsModal" tabindex="-1" role="dialog" aria-labelledby="transactionsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    @if (holding) {
      <div class="modal-content">
        <div class="modal-header">
          <div class="h5-text modal-title text-center w-100" id="transactionsModalLabel">{{holding.ProductName}}{{holding.CusipNumFormated}}</div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div>
            <span class="mr-4">
              <b>Current price: </b>
              {{holding.CurrentPrice === 0? 'N/A': holding.CurrentPrice | currency:'USD': 'symbol':'1.0-4' | minusSignToParens | placeholder: '-'}}
            </span>
            <span class="mr-4">
              <b>Total units: </b>
              {{holding.TotalUnits | number:'1.0-3'}}
            </span>
            <span class="mr-4">
              <b>Market Value: </b>
              {{holding.MarketValue | currency:'USD': 'symbol':'1.0-0' | minusSignToParens | placeholder: '-'}}
            </span>
            <span>
              <b>Annualized Return Since Inception: </b>
              @if (isLessThanOneYear(holding.AcctInception, 0)) {
                @if (holding.InceptionReturn === 0) {
                  N/A
                }
                @if (holding.InceptionReturn !== 0) {
                  {{holding.InceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}<span class="ARSI-star" aria-hidden="true" [ngbTooltip]="'Funds are invested for less than one year. Displayed return uses YTD return formula, refer to the FAQ page.'" placement="top" container="body">* </span>
                }
              } @else {
                {{holding.InceptionReturn | percent:'1.2-2' | minusSignToParens | placeholder: '-'}}
              }
            </span>
          </div>
          <a (click)="PTr.export([[plan?.title + ' - Transactions']], [{row:0, font: '14'}])" class="export-btn pull-right d-print-none mt-4">Export</a>
          @if (!isPortfolioInvestmentPage) {
            <h1 class="my-4">Transaction Details</h1>
          }
          @if (isPortfolioInvestmentPage) {
            <div class="h3-text my-4">Transaction Details</div>
          }
          <portfolio-transactions [holding]="holding" [plan]="plan" #PTr />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    }
  </div>
</div>
